import countryCodes from 'country-codes-list'

const countriesList = countryCodes.customList('countryCode', '{countryNameEn}')

export const getCountryName = (code: string): string => {
  const arr = Object.entries(countriesList).filter((obj) => obj[0] === code)
  const countryName = arr.map((country) => country[1])
  return countryName[0] as string
}
